module.exports = __webpack_public_path__ + "static/media/whitoutWhen.9ed8bb26.svg";